export default __webpack_public_path__ + "static/media/o16.da472159.jpg";